import { IReducer } from './';
import { Entity, NetworkPaginationSlice, NetworkArray, IEntitySet, isNetworkArray } from './entityReducers';
import { deepAssign, deepClone } from 'typed/utils';

type A<R> = R extends IReducer<any, infer a> ? a : never;

export default function childrenReducer<E extends Entity, S extends NetworkPaginationSlice<E>, R extends IReducer<any, any>>(def: S, reducer: R, keyExtractor: (s: NetworkPaginationSlice<E>, a: A<R>) => number): IReducer<S, A<R>>;
export default function childrenReducer<E extends Entity, S extends NetworkArray<E>, R extends IReducer<any, any>>(def: S, reducer: R, keyExtractor: (s: NetworkArray<E>, a: A<R>) => number): IReducer<S, A<R>>;
export default function childrenReducer<E extends Entity, S extends E[], R extends IReducer<any, any>>(def: S, reducer: R, keyExtractor: (s: E[], a: A<R>) => number): IReducer<S, A<R>>;
export default function childrenReducer<E extends Entity, R extends IReducer<any, any>>(def: IEntitySet<E>, reducer: R, keyExtractor: (s: any, a: A<R>) => number): IReducer<any, A<R>> {
    return function childrenReducer(state: IEntitySet<E> | undefined = deepClone(def), action: A<R>): IEntitySet<E> {
        const index = keyExtractor(state, action);
        if (index !== -1) {
            let data = isNetworkArray(state) ? state.Data : state;

            if (data[index]) {
                data = deepAssign(data, { [index]: reducer(data[index], action) });

                return isNetworkArray(state) ? deepAssign(state, { Data: data }) : data;
            }
        }
        return state;
    };
}
